import { Card, CardContent, Typography } from "@mui/material";

export default function VideoTestimonial() {
  return (
    <Card sx={{ boxShadow: 2, overflow: "hidden" }}>
      <CardContent>
        {/* Replace below with an actual video component later */}
        <div
          style={{
            width: "100%",
            height: "200px",
            background: "#ccc",
            position: "relative",
          }}
        >
          <button
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "white",
              borderRadius: "50%",
              width: 50,
              height: 50,
            }}
          >
            ▶
          </button>
        </div>
        <Typography variant="h6" mt={2} sx={{ fontFamily: '"Poppins", serif' }}>
          Amit Behl
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          Bought Damage Protection for Samsung mobile
        </Typography>
      </CardContent>
    </Card>
  );
}
